import * as yup from "yup";

export const ChequeSettingsSetupValidationSchema = yup.object().shape({
  chequeFormat: yup
  .number()
  .required("Cheque Format is required"),
  dateFormat: yup
  .number()
  .required("Date Format is required"),
  printDateIndicators: yup
  .number()
  .required("Print Date Indicators is required"),
  printAddress: yup
  .number()
  .required("Print Address is required"),
  printChequeNo: yup
  .number()
  .required("Print Cheque No is required"),
  printPaymentDate: yup
  .number()
  .required("Print Payment Date is required"),
	notes: yup
    .string()
    .max(100, "Maximum length 100 characters"),
});
